var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08653 13.4569C6.92103 13.4572 6.76064 13.3996 6.6332 13.294C6.56147 13.2345 6.50219 13.1615 6.45873 13.0791C6.41527 12.9967 6.3885 12.9065 6.37994 12.8137C6.37139 12.7209 6.38122 12.6274 6.40888 12.5384C6.43654 12.4495 6.48147 12.3668 6.54112 12.2952L9.71445 8.49857L6.65445 4.69482C6.59561 4.62237 6.55167 4.539 6.52516 4.44951C6.49864 4.36002 6.49008 4.26617 6.49995 4.17336C6.50983 4.08055 6.53794 3.9906 6.58269 3.9087C6.62744 3.82679 6.68794 3.75453 6.7607 3.69607C6.83399 3.63159 6.91981 3.58295 7.01279 3.55321C7.10577 3.52347 7.20389 3.51326 7.301 3.52324C7.39811 3.53322 7.4921 3.56316 7.57709 3.61118C7.66208 3.65921 7.73622 3.72429 7.79487 3.80232L11.2161 8.05232C11.3203 8.17907 11.3773 8.33805 11.3773 8.50212C11.3773 8.66618 11.3203 8.82516 11.2161 8.95191L7.67445 13.2019C7.60339 13.2876 7.51313 13.3554 7.41098 13.3997C7.30883 13.444 7.19767 13.4636 7.08653 13.4569Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.87efc8b5fa6197d277c5c011a48e084e.svg";
export { ForwardRef as ReactComponent };